var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 604.5 343.96",
    style: {
      enableBackground: "new 0 0 604.5 343.96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);stroke:url(#SVGID_2_);stroke-width:0.5;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_3_);stroke:url(#SVGID_4_);stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{fill:url(#SVGID_5_);stroke:url(#SVGID_6_);stroke-width:0.5;stroke-miterlimit:10;}\n\t.st3{fill:url(#SVGID_7_);stroke:url(#SVGID_8_);stroke-width:0.5;stroke-miterlimit:10;}\n\t.st4{fill:url(#SVGID_9_);stroke:url(#SVGID_10_);stroke-width:0.5;stroke-miterlimit:10;}\n\t.st5{fill:url(#SVGID_11_);stroke:url(#SVGID_12_);stroke-width:0.5;stroke-miterlimit:10;}\n\t.st6{fill:url(#SVGID_13_);stroke:url(#SVGID_14_);stroke-width:0.5;stroke-miterlimit:10;}\n\t.st7{fill:url(#SVGID_15_);stroke:url(#SVGID_16_);stroke-width:0.5;stroke-miterlimit:10;}\n\t.st8{fill:url(#SVGID_17_);stroke:url(#SVGID_18_);stroke-width:0.5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -77.3038,
    y1: 112.2656,
    x2: 614.783,
    y2: 112.2656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.4408,
    y1: 112.2656,
    x2: 342.4048,
    y2: 112.2656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.28,98.39c0-19.93,15.9-28.89,16.8-29.59c-10.46-15-26.37-15.41-30.79-15.41 c-11.68,0-21.25,7.15-27.38,7.15c-6.44,0-15-6.74-25.26-6.74c-19.32,0-38.95,16.01-38.95,46.19c0,18.82,7.25,38.66,16.23,51.42 c7.74,10.87,14.49,19.72,24.14,19.72c9.67,0,13.89-6.33,25.76-6.33c12.2,0,14.91,6.13,25.47,6.13c10.57,0,17.51-9.55,24.15-19.12 c7.45-10.87,10.58-21.54,10.67-22.04C341.51,129.58,321.28,121.43,321.28,98.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -77.2971,
    y1: 24.3987,
    x2: 614.7745,
    y2: 24.3987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.6453,
    y1: 24.3987,
    x2: 311.162,
    y2: 24.3987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.91,30.25v18.3h-11.65V32.23c0-11.21-9.12-20.33-20.33-20.33c-11.26,0-20.38,9.12-20.38,20.33v16.31 H246.9v-18.3h0.1c0.99-16.71,14.93-30,31.93-30c17.01,0,30.89,13.29,31.88,30H310.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -68.2173,
    y1: 260.986,
    x2: 586.209,
    y2: 260.986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 260.986,
    x2: 89.9518,
    y2: 260.986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.66,224.19c-2.05-5.03-4.88-9.57-8.53-13.64c-3.66-4.07-7.93-7.3-12.83-9.69 c-4.91-2.39-10.29-3.6-16.16-3.6H0.25v127.44h19.63v-42.71h30.16c8.02,0,14.96-2.04,20.82-6.1c5.86-4.07,10.47-9.33,13.82-15.8 c3.35-6.46,5.03-13.28,5.03-20.46C89.7,234.37,88.69,229.21,86.66,224.19z M62.42,250.49c-1.44,3.17-3.35,5.59-5.75,7.26 c-2.39,1.68-5.09,2.51-8.08,2.51H19.88v-41.28h27.64c2.99,0,5.78,0.78,8.35,2.33c2.57,1.56,4.66,3.9,6.28,7 c1.62,3.11,2.42,6.89,2.42,11.31C64.58,243.7,63.86,247.32,62.42,250.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -77.2753,
    y1: 277.0495,
    x2: 614.7269,
    y2: 277.0495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.3551,
    y1: 277.0495,
    x2: 160.8525,
    y2: 277.0495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158.82,229.39h-3.05c-5.75,0.37-11.19,2.4-16.34,6.1c-5.15,3.71-9.4,8.8-12.75,15.26v-19.21h-22.07v93.16 h24.05v-56.9c2.52-5.27,6.65-9.3,12.38-12.11c5.75-2.81,12.27-4.22,19.56-4.22v-21.9C160.12,229.45,159.53,229.39,158.82,229.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -77.3644,
    y1: 259.1884,
    x2: 614.8845,
    y2: 259.1884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.8137,
    y1: 259.1884,
    x2: 198.3724,
    y2: 259.1884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.06,230.66v94.05h24.06v-94.05H174.06z M186.18,193.67h-0.17c-6.59,0-11.95,5.35-11.95,11.95 s5.35,11.94,11.95,11.94h0.17c3.3,0,6.28-1.34,8.44-3.49c2.16-2.16,3.5-5.14,3.5-8.44C198.12,199.02,192.77,193.67,186.18,193.67z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -77.2987,
    y1: 278.1259,
    x2: 614.7786,
    y2: 278.1259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.1472,
    y1: 278.1259,
    x2: 306.1808,
    y2: 278.1259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.02,231.54l-23.87,71.48l-23.69-71.48h-24.95l34.65,93.16h26.2l34.47-93.16H283.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -77.3244,
    y1: 278.3089,
    x2: 614.7899,
    y2: 278.3089
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.3342,
    y1: 278.3089,
    x2: 402.6408,
    y2: 278.3089
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M397.99,303.2c-0.9-1.06-1.35-2.83-1.35-5.31v-29.56c0-12.26-3.74-21.7-11.21-28.3 c-7.48-6.62-17.92-9.92-31.32-9.92c-7.18,0-14.04,1.02-20.56,3.05c-6.52,2.04-12.9,5.09-19.12,9.16l7.71,15.79 c5.15-3.46,10.05-6.09,14.73-7.89c4.66-1.8,9.57-2.7,14.72-2.7c6.94,0,12.18,1.59,15.71,4.76c3.53,3.18,5.3,7.7,5.3,13.58v5.01 c-2.99-1.32-6.53-2.27-10.59-2.87c-4.08-0.6-8.08-0.9-12.03-0.9c-7.9,0-14.9,1.24-21.01,3.73c-6.1,2.48-10.86,6-14.27,10.56 c-3.42,4.55-5.12,9.83-5.12,15.86c0,5.56,1.41,10.56,4.22,14.99c2.81,4.44,6.7,7.92,11.66,10.46c4.96,2.54,10.57,3.81,16.78,3.81 c6.34,0,12.56-1.43,18.67-4.31s11.19-6.94,15.26-12.21l0.54,4.85c0.6,3.11,2.12,5.74,4.57,7.9c2.46,2.15,6.08,3.23,10.87,3.23 c1.19,0,2.67-0.13,4.39-0.37c1.73-0.24,3.69-0.53,5.84-0.9v-19.56C400.35,304.91,398.89,304.26,397.99,303.2z M372.59,293.87 c0,1.17-0.42,2.46-1.26,3.86c-0.84,1.39-1.91,2.79-3.23,4.19c-2.15,1.99-4.96,3.65-8.43,4.99c-3.47,1.35-7,2.02-10.59,2.02 c-3.47,0-6.47-0.64-8.98-1.92c-2.52-1.29-4.43-2.98-5.75-5.08c-1.32-2.1-1.98-4.32-1.98-6.65c0-4.32,2.01-7.79,6.02-10.42 c4-2.62,9.12-3.93,15.34-3.93c2.99,0,6.17,0.32,9.52,0.96c3.34,0.64,6.46,1.54,9.33,2.71V293.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -77.29,
    y1: 278.3089,
    x2: 614.7679,
    y2: 278.3089
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.9055,
    y1: 278.3089,
    x2: 505.9432,
    y2: 278.3089
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M482.08,294.91c-0.95,2.15-2.45,4.08-4.48,5.75c-2.04,1.67-4.34,2.99-6.91,3.95 c-2.57,0.96-5.3,1.43-8.16,1.43c-4.56,0-8.68-1.2-12.4-3.61c-3.71-2.4-6.67-5.7-8.88-9.87c-2.22-4.16-3.32-8.95-3.32-14.35 c0-5.52,1.09-10.36,3.24-14.53c2.14-4.17,5.11-7.39,8.88-9.68c3.76-2.3,7.92-3.44,12.48-3.44c4.05,0,7.78,0.93,11.12,2.78 c3.34,1.86,6.04,4.53,8.08,8l23.52-7.19c-3.58-7.17-9.03-12.98-16.34-17.4c-7.29-4.43-16.03-6.65-26.2-6.65 c-10.18,0-18.97,2.19-26.39,6.57c-7.42,4.38-13.14,10.21-17.14,17.48c-4.01,7.27-6.02,15.29-6.02,24.05 c0,6.4,1.17,12.49,3.5,18.29c2.34,5.8,5.65,10.97,9.96,15.53c4.32,4.56,9.52,8.1,15.62,10.65c6.09,2.54,12.98,3.81,20.64,3.81 c6.94,0,13.19-1.05,18.75-3.14c5.57-2.1,10.42-5,14.55-8.71c4.13-3.71,7.26-7.9,9.42-12.57L482.08,294.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -77.331,
    y1: 287.626,
    x2: 614.7765,
    y2: 287.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 508.2794,
    y1: 287.626,
    x2: 604.5043,
    y2: 287.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M581.17,231.54l-22.26,69.01l-25.3-69.01h-24.96l37.16,93.43c-1.56,5.18-3.05,9.23-4.49,12.11 c-1.43,2.88-2.91,4.9-4.39,6.03c-0.29,0.22-0.6,0.42-0.92,0.59h28.57c0.03-0.06,0.05-0.13,0.07-0.19l39.5-111.97H581.17z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.b884941bf21e4a104aa84b30713e4c2d.svg";
export { ForwardRef as ReactComponent };